package com.sweetlime.dungeonamigo.cache

import app.cash.sqldelight.Transacter
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import com.sweetlime.dungeonamigo.cache.shared.newInstance
import com.sweetlime.dungeonamigo.cache.shared.schema
import kotlin.Unit

public interface SrdDatabase : Transacter {
  public val srdDatabaseQueries: SrdDatabaseQueries

  public companion object {
    public val Schema: SqlSchema<QueryResult.Value<Unit>>
      get() = SrdDatabase::class.schema

    public operator fun invoke(driver: SqlDriver): SrdDatabase =
        SrdDatabase::class.newInstance(driver)
  }
}
